<template>
    <div>
        <div class="px-5 flex-level">
            <CompassIcon
                v-if="data.icon"
                class="mr-3"
                type="primary"
                size="medium"
                :icon="data.icon"
            />
            <div>
                <slot name="title" :data="data">
                    <span class="semibold gray-60">{{ data.label }}</span>
                </slot>
            </div>
            <div class="flex-right fs-2">
                <a
                    v-if="data.count > 3 && !allResult"
                    href="javascript:;"
                    class="link fs-2"
                    @click="toggleSeeMore"
                    >{{ labelSeeMore }}</a
                >
                <slot name="results" :data="{ nbResult: data.count ? data.count : 0 }">
                    <span class="grey ml-2">{{
                        $l10n.n__('%d résultat', '%d résultats', data.count, data.count)
                    }}</span>
                </slot>
            </div>
        </div>
        <ul v-if="!groupBy.length" class="my-1">
            <li
                v-for="(item, itemIndex) in reducedResults"
                :key="itemIndex"
                class="hover-primary-05-bkg px-5 py-2"
            >
                <a :href="item.link" class="pointer">
                    <slot name="content" :data="item" />
                </a>
            </li>
        </ul>
        <div v-else class="my-2">
            <template v-for="group in groupBy">
                <div v-if="groupedResults(group.key).length" :key="group.key" class="mb-2">
                    <span class="semibold ml-5">{{ group.label }}</span>
                    <ul class="mt-0">
                        <li
                            v-for="(item, itemIndex) in groupedResults(group.key)"
                            :key="itemIndex"
                            class="hover-primary-05-bkg px-5 py-2"
                        >
                            <a :href="item.link" class="pointer">
                                <slot name="content" :data="item" />
                            </a>
                        </li>
                    </ul>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
const MINRESULT = 3;

export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        allResult: {
            type: Boolean,
            required: false,
            default: false,
        },
        groupBy: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    data() {
        return {
            nbResults: MINRESULT,
        };
    },
    computed: {
        reducedResults() {
            if (!this.allResult) {
                return this.reduceResults(this.data.items);
            }

            return this.data.items;
        },
        labelSeeMore() {
            return this.seeMore ? this.$l10n.__('Voir plus') : this.$l10n.__('Voir moins');
        },
        seeMore() {
            return this.nbResults == MINRESULT;
        },
    },
    methods: {
        toggleSeeMore() {
            this.$emit('processByType', { type: [this.data.key] });
        },
        groupedResults(key) {
            if (this.allResult) return this.groupResults(key);

            if (this.seeMore) return this.reduceResults(this.groupResults(key));
            // Divide equally result by the total number of groups
            else
                return this.reduceResults(
                    this.groupResults(key),
                    Math.floor(this.nbResults / this.groupBy.length),
                );
        },
        groupResults(key) {
            return this.data.items.filter((item) => item.type === key);
        },
        reduceResults(data, forceMaxResults) {
            return data
                .slice(0, !_.isNil(forceMaxResults) ? forceMaxResults : this.nbResults)
                .map((i) => {
                    return i;
                });
        },
    },
};
</script>

<style lang="scss">
.search-result-item {
    max-width: 200px;
}
</style>
